import getProductKey from 'helper/requests/getProductKey';
import { WeatherArea } from 'types/Meteorology/Weather/Area';
import GetAboutParams from 'types/Meteorology/Weather/Area/getAboutParams';
import EditAboutDescriptionParams from 'types/Meteorology/Weather/Area/editAboutDescriptionParams';
import baseApi, { GenericResponse } from 'services/api/base';
import transformGetAboutResponse from 'helper/Meteorology/Weather/Area/About';
import filterUndefined from 'utils/filterUndefined';

export const weatherAreaApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getAbout: build.query<WeatherArea, GetAboutParams>({
      transformResponse: transformGetAboutResponse,
      query: ({ area, polarity }) => {
        const productKey = getProductKey('meteorologia');
        return {
          url: `produtos/clima_exclusivo/about/?product_key=${productKey}`,
          method: 'POST',
          body: filterUndefined({ area, polarity }),
        };
      },
    }),
    editAboutDescription: build.mutation<GenericResponse<null>, EditAboutDescriptionParams>({
      query: ({ id, description }) => {
        const productKey = getProductKey('meteorologia');
        return {
          url: `produtos/clima_exclusivo/edit-descricao-about/?product_key=${productKey}`,
          method: 'POST',
          body: { id, descricao: description },
        };
      },
    }),
  }),
});

export const {
  useGetAboutQuery,
  useEditAboutDescriptionMutation,
} = weatherAreaApi;
